import { Pack } from 'types/generated/graphql';

export const isPack = (item: unknown): item is Pack => {
    return (item as Pack).__typename === 'Pack';
};
